// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5fb98dd","732":"5b97ae2d","977":"4cd88508"}[chunkId] + ".chunk.js";
};